   <button type="button" mat-button class="with-icon"
          ngfSelect [(files)]="files"
          (filesChange)="importFromCsv($event)"
          accept=".csv" multiple="1"
          [matTooltip]="'settings.import_procedure_tooltip'|translate">
        <mat-icon fontSet="mdi" fontIcon="mdi-import"></mat-icon>
        <span>{{ 'settings.import' | translate }}</span>
   </button>
